import { Fragment, ReactNode } from "react";
import { translate } from "./translate";

// Pseudo-unique string separator to find the tokens in the string easier
const separator = "||7zhgvhoohv||";

/**
 * Translate a phrase that contains tokens rendered as React components.
 * The available tokens are "%1", "%2" and so on.
 */
export const translateReact = (text: string, args: ReactNode[]) =>
    translate(
        text,
        args.map((_, index) => `${separator}%${index + 1}${separator}`)
    )
        .split(separator)
        .map((str): ReactNode => {
            for (const [index, node] of args.entries()) {
                if (str === `%${index + 1}`) {
                    return node;
                }
            }
            return str;
        })
        .map((node, index) => {
            return <Fragment key={index}>{node}</Fragment>;
        });
